// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomEmojiPicker_wrapper__3dCfV","emojiWrapper":"CustomEmojiPicker_emojiWrapper__3Y-W2"};